import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { signIn } from "../../../redux/actions/authActions";
import useInput from "../../hooks/useInput";
import ProviderSignIn from "../ProviderSignIn";

const SignIn = (props) => {
  /* state */
  const [email, setEmail] = useInput("");
  const [password, setPassword] = useInput("");

  /* redux store */
  const uid = useSelector((store) => store.firebase.auth.uid);

  /* redux dispatch */
  const dispatch = useDispatch();

  /*functions */
  const handleSubmit = (event) => {
    event.preventDefault();
    dispatch(signIn({email, password}));
  };

  if (uid) return <Redirect to="/" />;

  return (
    <>
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          value={email}
          placeholder="email"
          onChange={setEmail}
        />
        <input
          type="password"
          value={password}
          placeholder="password"
          onChange={setPassword}
        />
        <button type="submit">
          Sign In
        </button>
      </form>
    <ProviderSignIn provider = "google"/>
    </>
  );
};

export default SignIn;
